export class MathsNaiveDynamic {
    public sampleInt: number = 0.01;
    public split_tg: boolean = false;
    public split_tr: boolean = false;
    public split_ts_val: number = 0.3;
    public split_tr_val: number = 0.1;
    public split_tr_sign: string = "ne";
    public split_tr_pretrig: number = 50;
    public split_tr_postrig: number = 50;
}
